<div class="form-header">
  <span *ngIf="fromFamilyPatient">Edit family patients</span>
  <span *ngIf="edited.id && !fromFamilyPatient">Edit</span>
  <span *ngIf="!edited.id">Add</span>
  family
</div>
<form class="form-view" [formGroup]="familyForm" (ngSubmit)="onSubmitForm(familyForm)">
  <div class="dialog-container" *ngIf="panel == 0">
    <div class="dialog-fields" *ngIf="!fromFamilyPatient">
      <div class="field">
        <mat-form-field  required>
          <input matInput placeholder="Identifier" formControlName="identifier" name="identifier">
          <mat-hint class="select-hint">Randomly assigned if blank</mat-hint>
        </mat-form-field>
      </div>
      <mat-form-field class="field">
        <mat-select  name="status" formControlName="status" placeholder="Set status">
          <mat-option *ngFor="let s of statuses" [value]="s">{{s.replaceAll('_', ' ') | titlecase}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="field" *ngIf="familyForm.value.status === 'ONBOARDED'  && (!(useRandomServiceLevelAssignment))">
        <mat-select  name="serviceLevel" formControlName="serviceLevel" placeholder="Add a service level">
          <mat-option *ngFor="let r of getServiceLevelNames()" [value]="getServiceLevelForName(r)">{{r}}</mat-option>
        </mat-select>
        <mat-hint class="select-hint" *ngIf="useRandomServiceLevelAssignment">Randomly assigned</mat-hint>
      </mat-form-field>

      <mat-form-field class="field" *ngIf="familyForm.value.status === 'ONBOARDED'">       
        <mat-select multiple required name="teams" formControlName="teams" placeholder="Select teams">
          <mat-option *ngFor="let r of groups" [value]="r">{{r.name}}</mat-option>
        </mat-select>
        <mat-hint class="select-hint">Assign a team.</mat-hint>
      </mat-form-field>
      <mat-form-field class="field">
        <input type="text" formControlName="tags" name="tags" matInput placeholder="Enter tags separated by commas">
      </mat-form-field>


  </div>
    <div class="horizontal-border-panel">
    <div class="panel-label">Search for an existing or create a new patient</div>
      <div class="panel-body">
        <mat-form-field class="full-field">
          <button type="button" class="search-icon" (click)="getPageOfPatients($event)" matPrefix
            mat-button><mat-icon>search</mat-icon></button>
          <input type="text" (keydown)="getPageOfPatients($event)" formControlName="search" name="search" matInput
            placeholder="Search for patients" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let patient of patients" [value]="patient.description">{{patient.description}}</mat-option>
          </mat-autocomplete>
        
        </mat-form-field>
        <button class="add-button" (click)="addPatient()" [disabled]="getSelectedPatient() &&!validPatientSelected()" type="button"
          mat-flat-button color="primary"><span *ngIf='getSelectedPatient()'>Add</span><span *ngIf='!getSelectedPatient()'>Create</span></button>
        <mat-form-field class="full-field">
         
          <mat-select name="familyRelationship" formControlName="familyRelationship" placeholder="Relationship type">
            <mat-option *ngFor="let r of getFamilyRelationships()" [value]="r">{{r}}</mat-option>
          </mat-select>
          <mat-hint class="select-hint">A family must have exactly one Primary patient.</mat-hint>
        </mat-form-field>
   
      </div>
    </div>
    <div  [ngClass]="{'list-panel': !fromFamilyPatient, 'list-panel-family-patient' : fromFamilyPatient}">
      <div class="patient-family-item" *ngFor="let pf of familyPatients; let n = index">
        <div class="patient-family-description">{{pf.relationship.replace('_', ' ')}} {{pf.description}} </div>
        <button type="button" class="remove-button" (click)="onRemovePatientFamily(pf.patientId)"
          mat-icon-button>
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="dialog-container" *ngIf="panel === 1">
    <mat-form-field class="notes-field">
      <mat-label>Add Some Notes</mat-label>
        <textarea matInput formControlName="notes" name="notes"  rows="8" columns="120" maxlength="255"></textarea>
    </mat-form-field>
  </div>
  <div class="button-container">
    <button class="dialog-button" color="primary" (click)="panel=1" *ngIf="panel === 0" type="button" mat-flat-button>Notes</button>
    <button class="dialog-button" color="primary" (click)="panel=0" *ngIf="panel === 1" type="button" mat-flat-button>Base Info</button>
    <button class="dialog-button" [disabledInteractive]="isFormInValid()" [disabled]="isFormInValid()" type="submit" mat-flat-button
      color="primary">Save</button>
    <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
  </div>
</form>